/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faEngineWarning} from '@fortawesome/pro-duotone-svg-icons';

const BehaviorIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faEngineWarning} {...props} />
);

export default BehaviorIcon;
